module.exports = __webpack_public_path__ + "media/ca_slide29_muntatge_ensamblatge.f4699d3f.mp4";